import React from 'react'

export default function BottomStickyActions({ children }){
  return (
    <div className="sticky-actions">
      <div className="inner">
        {children}
      </div>
    </div>
  )
}
